// Built-in views (docs/director-reporting-prototype.md, P5). Values match utils/columns filterValues
// and the status labels from registrationAdapter. Apart from "All registrations", each view shows
// attending participants only (Active, payment Pending, and Refunded without cancelling): a
// check-in list, a balance chase or an apparel order has no use for cancelled ones.

const ACTIVE = ['Active', 'Pending', 'Refunded'];

export const builtInViews = [
  {
    id: 'all',
    name: 'All registrations',
    description: 'Every column, no filters',
    builtIn: true,
    state: {},
  },
  {
    id: 'front-desk',
    name: 'Front desk check-in',
    description: 'Attending participants grouped by program',
    builtIn: true,
    state: {
      columnFilters: { status: ACTIVE },
      sort: { key: 'participant', direction: 'asc' },
      groupBy: 'program',
      visibleKeys: ['participant', 'status', 'statusNote', 'stay', 'primaryGuardian', 'documents', 'medical', 'allergy'],
    },
  },
  {
    id: 'balance-due',
    name: 'Balance due',
    description: 'Bookings with money outstanding',
    builtIn: true,
    state: {
      columnFilters: { status: ACTIVE, payment: ['Balance due', 'Overdue'] },
      sort: { key: 'payment', direction: 'desc' },
      visibleKeys: ['bookingDate', 'participant', 'bookingNumber', 'program', 'primaryGuardian', 'payment', 'paymentType', 'statusNote'],
    },
  },
  {
    id: 'missing-documents',
    name: 'Missing documents',
    description: 'Participants with documents still to come',
    builtIn: true,
    state: {
      columnFilters: { status: ACTIVE, documents: ['Missing documents'] },
      visibleKeys: ['participant', 'program', 'primaryGuardian', 'documents', 'medicalReview', 'insuranceCompany', 'statusNote'],
    },
  },
  {
    id: 'apparel',
    name: 'T-shirt & shorts order',
    description: 'Sizes grouped by program',
    builtIn: true,
    state: {
      columnFilters: { status: ACTIVE },
      groupBy: 'program',
      sort: { key: 'tshirtSize', direction: 'asc' },
      density: 'compact',
      visibleKeys: ['participant', 'tshirtSize', 'shortsSize'],
    },
  },
  {
    id: 'medical',
    name: 'Medical & allergies',
    description: 'Participants with medical or allergy information',
    builtIn: true,
    state: {
      tab: 'medical',
      columnFilters: { status: ACTIVE },
      sort: { key: 'participant', direction: 'asc' },
      visibleKeys: ['participant', 'program', 'medical', 'allergy', 'medicalReview', 'insuranceCompany', 'primaryGuardian'],
    },
  },
];
